import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Query } from 'react-apollo';
import './styles/dialog.scss';
import { GET_SST_DATA } from './queries/dialog.queries';

const DATA_POLL_INTERVAL = 10000;

const ShowMobileStateDialog = props => {
    const { source, open, onClose } = props;
    let allSSTs = [];

    if(open) {
      source.crosssections.forEach(crosssection => {
        crosssection.ssts.forEach(sst => {
          allSSTs.push(sst);
        });
      });
    }

    const handleClose = () => {
      onClose();
    };

    function convertMobileServiceTypeToString(mobileServiceType) {
        switch (mobileServiceType) {
          case 1:
            return "GSM";
          case 2:
            return "GPRS";
          case 3:
            return "EDGE";
          case 4:
            return "UMTS";
          case 5:
            return "HSPA";
          case 6:
            return "HSPA+";
          case 7:
            return "HSDPA";
          case 8:
            return "HSUPA";
          case 9:
            return "LTE";
          case 10:
            return "LTE-A";
          default:
            return "Unknown";
        }
      }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md">
          <DialogTitle>
            Aktueller Mobilfunkstatus
          </DialogTitle>

          <DialogContent>
            <Table size="medium" className="mobileStateDataTable">
              <TableHead>
                <TableRow>
                  <TableCell>Streckenstation</TableCell>
                  <TableCell>Provider</TableCell>
                  <TableCell>Signalstärke</TableCell>
                  <TableCell>Netztyp</TableCell>
                  <TableCell>Area ID</TableCell>
                  <TableCell>Area Code</TableCell>
                  <TableCell>Cell Identity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>

                {allSSTs.map(sst => (
                  <Query query={GET_SST_DATA} variables={{id: sst.id}} pollInterval={DATA_POLL_INTERVAL} fetchPolicy="network-only">
                    {({ data, error, loading }) => {
                            
                      if (data !== undefined && data.sst !== undefined) {
                        if (data.sst.mobile_router_data === undefined || data.sst.mobile_router_data === null) {
                          return null;
                        }
                        let mobileState = data.sst.mobile_router_data;
                        let status = (mobileState.location_area_id == 65535 ? "nok" : "ok");                                    
                        return  (
                          <TableRow key={sst.name}>
                            <TableCell component="th" scope="row">
                              {sst.name}
                            </TableCell>                        
                            <TableCell>{status == "nok" ? " " : (mobileState.mobile_provider)}</TableCell>
                            <TableCell>{status == "nok" ? " " : (mobileState.signal_strength + " dBm")}</TableCell>
                            <TableCell>{status == "nok" ? " " : (convertMobileServiceTypeToString(mobileState.mobile_service_type))}</TableCell>
                            <TableCell>{status == "nok" ? " " : (mobileState.location_area_id)}</TableCell>
                            <TableCell>{status == "nok" ? " " : (mobileState.location_area_code)}</TableCell>
                            <TableCell>{status == "nok" ? " " : (mobileState.cell_identity)}</TableCell>
                          </TableRow>
                        );
                      }
                      return null;
                      }}
                  </Query>
                ))}

              </TableBody>
            </Table>
            
          </DialogContent>

          <DialogActions>
            <Button color="primary" onClick={handleClose}>Verlassen</Button>       
          </DialogActions>
        </Dialog>
  );
};

ShowMobileStateDialog.propTypes = {
  source: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onVerifyClick: PropTypes.func.isRequired
};

export default ShowMobileStateDialog;